import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const UIContext = createContext(null);
const THEME_KEY = 'cluster_ui_windows_nt';

export function UIProvider({ children }) {
  const [autoRefresh, setAutoRefresh] = useState(true);
  const [windowsNT, setWindowsNT] = useState(() => localStorage.getItem(THEME_KEY) === 'true');
  const [toast, setToast] = useState(null);

  const toggleWindowsNT = useCallback((enabled) => {
    setWindowsNT(enabled);
    localStorage.setItem(THEME_KEY, String(enabled));
  }, []);

  const notify = useCallback((type, title, message) => {
    setToast({ id: Date.now(), type, title, message });
  }, []);

  const value = useMemo(() => ({
    autoRefresh,
    setAutoRefresh,
    windowsNT,
    setWindowsNT: toggleWindowsNT,
    toast,
    clearToast: () => setToast(null),
    notify,
  }), [autoRefresh, notify, toast, toggleWindowsNT, windowsNT]);

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}

export function useUI() {
  const context = useContext(UIContext);
  if (!context) throw new Error('useUI must be used within UIProvider');
  return context;
}
